<div class="panel" *ngIf="!loading ">
  <div class="panel_title" >
    Cost Details
  </div>
  <div class="panel_devider" ></div>
  <app-sku-info  [sku]="costDetail"></app-sku-info>
  <div class="panel-detail">
    <span class="panel-detail_value"><span class="label">Prep Cost</span> <br> {{ costDetail?.SkuPrep || 0 | currency }}</span>
    <span class="panel-detail_value"><span class="label">Item Cost</span> <br> {{ costDetail?.SkuCost || 0| currency }}</span>
    <span class="panel-detail_value"><span class="label">Total Cost</span> <br> {{ costDetail?.totalCost|| 0 | currency }}</span>
  </div>
  <div class="section" >
    <div class="section_title d-flex align-items-center justify-content-between">Cost & Custom Cost
      <app-button [buttonSize]="'action'" (click)="addCustomCost()"><i class="fal fa-plus"></i>Add New</app-button>
    </div>
    <div class="section_costBox section_header border-0 mb-0">
      <div class="section_costBox-firstCol label">
        Status
      </div>
      <span class="section_costBox-date label">Date</span>
      <span class="section_costBox-price label">Amount</span>
      <span class="section_costBox-price label">Remaining</span>
    </div>
    <div class="section_costBox"  *ngFor="let cost of costList; let i = index" [ngClass]="(cost?.isHighlight===true) ? 'section_selected' : ''">
      <div class="section_costBox-firstCol">
        <span class="badges" [ngClass]="(cost.isPeriod ===true) ? 'badges-period' : 'badges-qty'">{{ cost.name}}</span>
      </div>
      <span class="section_costBox-date"> {{cost?.dateFrom | date:'MM/dd/yy'}} - 
         {{ cost?.dateTo ?  (cost?.dateTo | date:'MM/dd/yy' ) : cost?.qty }} </span>
      <span class="section_costBox-price">{{cost?.price | currency}}</span>
    <span class="section_costBox-price">{{cost.remaining}}</span>
      <span class="ms-auto">
        <i class="far fa-edit pointer text-primary" (click)="edit(cost)" ></i>
        <i class="fal fa-trash-alt text-red ms-2 pointer" (click)="delete(cost.customCostId)"></i>
      </span>
    </div>
  </div>
</div>
<div class="no-result" *ngIf="loading">
  <app-no-results [message]="'Loading Cost Details'"></app-no-results>
</div>
